import React, { useState } from 'react'
import axios from 'axios'

import { AddUpdateProductsView } from './AddUpdateProductsView'


export const AddUpdateProducts = () => {
    const [data, setData] = useState()

    const onChangeUpdate = (e) => {
        setData(e.target.value)
    }

    const onClickSubmit = () => {
        console.log(data)
        axios.post(process.env.REACT_APP_HOST + 'api/reports/addProducts', {
            params: {
                data: data
            }
        }).then((res) => {
            console.log('response', res.data)
        })
    }

    return <AddUpdateProductsView
        onChangeUpdate={onChangeUpdate}
        onClickSubmit={onClickSubmit}
    />
}